<div class="bg-app-bar px-6 py-12 overflow-auto w-full">
  <!-- Header -->
  <div class="text-center mb-8">
    <p class="text-sm font-medium text-gray-400 uppercase mb-2">Minha assinatura</p>
    <h1 class="text-4xl font-extrabold text-white mb-2">Seus Planos</h1>
    <p class="text-lg text-gray-300">Confira seu plano atual e explore outras opções.</p>
  </div>

  <!-- Cards -->
  @if (!carregando) {
    <div class="max-w-screen-lg mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8 px-4">
      @for (plan of planos; track plan.id) {
        <div class="bg-card rounded-lg shadow p-8 flex flex-col relative"
             [ngClass]="isPlanoAtual(plan.id) ? 'border-4 border-primary' : ''">

          <!-- Badge: Plano vigente -->
          @if (isPlanoAtual(plan.id)) {
            <div class="absolute -top-5 inset-x-0 flex justify-center">
              <span class="bg-primary text-white text-xs uppercase py-1 px-3 rounded-full border-2 border-secondary">
                Plano vigente
              </span>
            </div>
          }

          <!-- Conteúdo -->
          <div>
            <h2 class="text-2xl font-semibold text-white mb-2">{{ plan.nome }}</h2>
            <ul class="list-disc list-inside space-y-3 text-gray-400 mb-6">
              <li>{{ labelUsuarios(plan) }}</li>
              <li>Acesso à plataforma Edduca Imob</li>
            </ul>
          </div>

          <!-- Preço + Ação -->
          <div class="mt-auto">
            <div class="mb-4">
              <span class="text-sm text-gray-400">R$</span>
              <span class="text-5xl font-extrabold text-white">
                {{ plan.preco | number: '1.2-2' }}
              </span>
              <span class="text-sm text-gray-400">/mês</span>
            </div>
            <button mat-flat-button color="primary" class="w-full mb-2"
                    (click)="gerenciarAssinatura()">
              {{ isPlanoAtual(plan.id) ? 'Gerenciar assinatura' : 'Trocar para este plano' }}
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
